LS.util.route({
	'blog': {
		'$index||category||tag||results': {
			'$any': {
				':load': 'blogs',
				':unload': 'blogs:unload'
			}
		},
		'$/^(?!(p\\d+|category|tag|results)).*$/': {
			':load': 'article',
			':unload': 'article:unload'
		}
	}
});